/* eslint-disable */

import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';
import ViewMiddleManager from 'views/relation-manager/viewmiddlemanager';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
let merchantEmpID;
const isEmployee = localStorage.getItem('isEmployee');
if (isEmployee === 'true') {
    merchantEmpID = localStorage.getItem('empId');
}
export const commonPost = async (apiEndPoint, payload, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
export const commonGetRequest = async (apiEndPoint, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await commonGetRequest(endpoint, payload) // Pass params for GET
                : await commonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};

export const GET_API_ENDPOINTS = {
    getActiveZoneHead: 'rm/getActiveZoneHead',
    getProfile: 'rm/settings',
    graphData: 'rm/report/totalGraphData',
    listSuperdistributorClass: 'rm/superdistributor/classList',
    rentalPlan: 'rm/getRentalPlan'
};

export const POST_API_ENDPOINTS = {
    getStates: 'rm/states',
    storeZonehead: 'rm/StoreZonehead',
    listZonehead: 'rm/list/zonehead',
    editZonehead: 'rm/edit/zonehead',
    viewZonehead: 'rm/view/zonehead',
    statusChange: 'rm/changeHeadStatus',
    storeStateHead: 'rm/statehead/store',
    listStatehead: 'rm/statehead/list',
    viewStatehead: 'rm/statehead/view',
    getActiveStateHead: 'rm/getActiveStateHead',
    panVerification: 'rm/panVerification',
    storeMiddlemanager: 'rm/middlemanager/store',
    listMiddlemanager: 'rm/middlemanager/list',
    viewMiddleManager: 'rm/middlemanager/view',
    getActiveMiddleManager: 'rm/getActiveMiddleManager',
    storeManager: 'rm/manager/store',
    listManager: 'rm/manager/list',
    viewManager: 'rm/manager/view',
    updateManager: 'rm/manager/update',
    updateMiddleManager: 'rm/middlemanager/update',
    updateStateHead: 'rm/statehead/update',
    listCsp: 'rm/csp/list',
    cspStatusChange: 'rm/csp/changeStatus',
    storeCsp: 'rm/csp/store',
    getActiveManager: 'rm/getActiveManager',
    getDistrict: 'rm/district',
    viewCsp: 'rm/csp/view',
    updateCsp: 'rm/csp/update',
    getActiveCsp: 'rm/getActiveCsp',
    bankAccountVerification: 'rm/BankAccountVerification',
    createSuperdistributor: 'rm/superdistributor/create',
    listSuperdistributor: 'rm/superdistributor/list',
    viewSuperdistributor: 'rm/superdistributor/view',
    superdistributorMapping: 'rm/superdistributor/mapping',
    getActiveSuperdistributor: 'rm/superdistributor/getActiveSuperDist',
    listDistributor: 'rm/distributor/list',
    viewDistributor: 'rm/distributor/view',
    posTxnTrack: 'rm/report/POS',
    qrTxnTrack: 'rm/report/QR',
    aepsTxnTrack: 'rm/report/AEPS ',
    bbpsTxnTrack: 'rm/report/BBPS ',
    dmtTxnTrack: 'rm/report/DMT ',
    matmTxnTrack: 'rm/report/MATM ',
    rechargeTxnTrack: 'rm/report/RECHARGE  ',
    listMerchant: 'rm/merchant/list',
    callToAgent: 'rm/Calltoagents',
    viewMerchant: 'rm/merchant/view',
    listCity: 'rm/city',
    getDistributorEmployee: 'rm/getDistributorEmployee',
    dailySalesMonitoringReport: 'rm/report/dailySalesMonitoring',
    txnReport: 'rm/report/TxnData',
    updatePassword: 'rm/updatePassword',
    dailySalesReport: 'rm/report/dailySalesReportTxnData',
    aepsMonthReport: 'rm/totalAgentsList',
    updateSuperdistributor: 'rm/superdistributor/update',
    addDistributor: 'rm/distributor/store',
    editDistributor: 'rm/distributor/edit',
    totalReportList: 'rm/TotalReportList',
    activeAgents: 'rm/getActiveAgents',
    rentalRequest: 'rm/rentalRequest',
    submittedList: 'rm/submittedRentalRequestList',
    rentalRequestList: 'rm/rentalRequestList',
    rentalStatusUpdate: 'rm/statusUpdateRentalRequest',
    updateSerialNo: 'rm/updateDeviceNo',
    updateRentalRequest: 'rm/updateRentalRequest',
    ssRmBcDashboard: 'rm/sso/AgentLogin',
    ConvertAsAgent: 'rm/onboard/ConvertAsAgent',
    pincodeVerification: 'verifyPincode',
    BCPhysicalVerification: 'rm/BCPhysicalVerification',
    BCPhysicalVerificationSendEmail: 'rm/BCPhysicalVerification/SendEmail',
    salesTargetDashboard: 'rm/sales-dashboard',
    retailerDetails: 'rm/retailerDetails'
};

export const getStatesList = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getStates, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const storeZoneheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.storeZonehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const listZoneheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listZonehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const editZoneheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.editZonehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewZoneheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewZonehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const statusChangeApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.statusChange, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const storeStateHeadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.storeStateHead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const getActiveZoneHeadApi = async (params) => {
    const response = await commonGetRequest(GET_API_ENDPOINTS.getActiveZoneHead, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listStateheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listStatehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewStateheadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewStatehead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateStateHeadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updateStateHead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const getActiveStateHeadApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getActiveStateHead, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const panVerificationApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.panVerification, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const storeMiddlemanagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.storeMiddlemanager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const listMiddlemanagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listMiddlemanager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewMiddleManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewMiddleManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getActiveMiddleManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getActiveMiddleManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateMiddleManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updateMiddleManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const storeManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.storeManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updateManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listCspApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listCsp, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const cspStatusChangeApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.cspStatusChange, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const storeCspApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.storeCsp, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getActiveManagerApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getActiveManager, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getDistrictApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getDistrict, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewCspApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewCsp, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateCspApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updateCsp, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getActiveCspApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getActiveCsp, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const bankAccountVerificationApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.bankAccountVerification, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const createSuperdistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.createSuperdistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listSuperdistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listSuperdistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewSuperdistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewSuperdistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const superdistributorMappingApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.superdistributorMapping, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getActiveSuperdistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getActiveSuperdistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listDistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listDistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewDistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewDistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const posTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.posTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const qrTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.qrTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const bbpsTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.bbpsTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const aepsTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.aepsTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const dmtTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.dmtTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const matmTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.matmTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const rechargeTxnTrackApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.rechargeTxnTrack, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listMerchantApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listMerchant, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const callToAgentApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.callToAgent, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewMerchantApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.viewMerchant, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listCityApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.listCity, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getDistributorEmployeeApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.getDistributorEmployee, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const dailySalesMonitoringReportApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.dailySalesMonitoringReport, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const txnReportApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.txnReport, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const getProfileApi = async (params) => {
    const response = await commonGetRequest(GET_API_ENDPOINTS.getProfile, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updatePasswordApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updatePassword, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const dailySalesReportApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.dailySalesReport, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const aepsMonthReportApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.aepsMonthReport, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const graphDataApi = async (params) => {
    const response = await commonGetRequest(GET_API_ENDPOINTS.graphData, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const listSuperdistributorClassApi = async (params) => {
    const response = await commonGetRequest(GET_API_ENDPOINTS.listSuperdistributorClass, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const updateSuperdistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.updateSuperdistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const addDistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.addDistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const editDistributorApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.editDistributor, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const totalReportListApi = async (payload, params) => {
    //API FOR LISTING EMPLOYEES
    const response = await commonPost(POST_API_ENDPOINTS.totalReportList, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const rentalPlan = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.rentalPlan, payload);
export const getActiveAgents = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.activeAgents, payload);
export const rentalRequestApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.rentalRequest, payload);
export const submittedRentalListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.submittedList, payload);
export const rentalRequestListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.rentalRequestList, payload);
export const rentalStatusUpdateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.rentalStatusUpdate, payload);
export const updateDeviceNoApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateSerialNo, payload);
export const editRentalRequestApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateRentalRequest, payload);
export const ssoRmBcDashboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ssRmBcDashboard, payload);
export const ConvertRmAsAgentApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ConvertAsAgent, payload);
export const pinVerification = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.pincodeVerification, payload);
export const BCPhysicalVerificationRM = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.BCPhysicalVerification, payload);
export const BCPhysicalVerificationSendEmailRM = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.BCPhysicalVerificationSendEmail, payload);
export const salesTargetDashboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.salesTargetDashboard, payload);

export const listRetailerDetailsApi = async (payload, params) => {
    //API FOR RETAILER DETAILS
    const response = await commonPost(POST_API_ENDPOINTS.retailerDetails, payload, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
